<template>
  <div>
    <div class="top-area ta-l">用户中心</div>
    <div class="my-private flex">
      <div class="left-content">
        <div
            class="fun-item"
            :class="activeTab=='custom'?'fun-item-active':''"
            @click="handleTab('custom')"
        >
          <el-icon class="el-icon-s-custom mr10"></el-icon>账户管理
        </div>
        <div
            class="fun-item mt20"
            :class="activeTab=='check'?'fun-item-active':''"
            @click="handleTab('check')"
        >
          <el-icon class="el-icon-s-check mr10"></el-icon>我的印章
        </div>
        <div
            class="fun-item mt20"
            :class="activeTab=='authorization'?'fun-item-active':''"
            @click="handleTab('authorization')"
        >
          <el-icon class="el-icon-s-flag mr10"></el-icon>应用授权
        </div>
        <div
            class="fun-item mt20"
            :class="activeTab=='order'?'fun-item-active':''"
            @click="handleTab('order')"
        >
          <el-icon class="el-icon-s-order mr10"></el-icon>订单列表
        </div>
        <div
            class="fun-item mt20"
            :class="activeTab=='product '?'fun-item-active':''"
            @click="handleTab('product')"
        >
          <el-icon class="el-icon-s-goods mr10"></el-icon>商品中心
        </div>
      </div>
      <div class="right-content flex1 mb30">
        <my-seal v-if="activeTab=='check'" ref="mySealRef"></my-seal>
        <my-custom v-if="activeTab=='custom'"></my-custom>
        <my-authorization v-if="activeTab=='authorization'" ></my-authorization>
      </div>
    </div>
  </div>
</template>

<script>

import MyCustom from "@/pages/userCenter/components/MyCustom.vue";
import MySeal from "@/pages/userCenter/components/MySeal.vue";
import MyAuthorization from "@/pages/userCenter/components/MyAuthorization.vue";

export default {
  name: "authorizationManage",
  components: {MyAuthorization, MySeal, MyCustom},
  data() {
    return {
      activeTab: "authorization"
    };
  },
  methods: {
    handleTab(tab) {
      if (tab == 'custom'){
        this.$router.push({
          path: "/userCenter/customManage"
        });
      }else if (tab == 'check'){
        this.$router.push({
          path: "/userCenter/myPrivateSeal"
        });
      }else if (tab == 'order'){
        this.$router.push({
          path: "/userCenter/order"
        });
      }else if (tab == 'product'){
        this.$router.push({
          path: "/userCenter/productCenter"
        });
      }
    }
  }
}
</script>

<style lang="less" scoped>
.top-area{
  width: 100%;
  margin-top: 40px;
  padding: 40px 30px 0;
  border-radius: 4px;
  font-size: 40px;
  color: #fff;
}
.my-private {
  width: 100%;
  min-height: 630px;
  margin-top: 20px;
  padding: 30px;
  background: #fff;
  border-radius: 4px;
  .left-content {
    width: 160px;
    .fun-item {
      width: 130px !important;
      margin-left: -40px;
      padding: 8px 10px;
      background-color: #fff;
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
      cursor: pointer;
    }
    .fun-item-active {
      color: #fff;
      background-color: #407fff;
    }
  }
  .right-content {
    min-height: 500px;
    padding: 0 0 50px 30px;
    border-left: 1px solid rgb(238, 238, 238);
  }
}
</style>
